import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
import { patientReportedLabel, withPatientReported } from '../../../core/utils/patient-reported';

@Component({
  selector: 'app-allergy-list-creator',
  templateUrl: './allergy-list-creator.component.html',
  styleUrls: ['./allergy-list-creator.component.scss']
})
export class AllergyListCreatorComponent extends BaseComponent implements OnChanges {
  @Input() heading: string = 'Allergies / Alerts';
  @Input() allergies: any[] = [];
  @Input() noAllergies: boolean = false;
  @Input() hideActions: boolean = false;
  @Input() hideCheckbox: boolean = false;
  @Output() allergiesChanged = new EventEmitter<any[]>();
  @Output() noAllergiesChanged = new EventEmitter<boolean>();

  editingAllergy: any = {};

  /** The "Patient reported" mark of a row the patient gave (their invite, or the patient app). */
  readonly reported = patientReportedLabel;

  @ViewChild('addAllergyDialog') addAllergyDialog?: TemplateRef<any>;

  constructor(fs: FeedbackService, md: MatDialog) {
    super(fs, md);
  }

  ngOnChanges(changes: SimpleChanges): void {

    if (changes['allergies'] && this.allergies.length > 0) {
      this.noAllergies = false;
    }
  }

  openAddAllergyDialog(): void {
    this.noAllergies = false;
    this.editingAllergy = { id: this.allergies.length + 1 };
    this.dialog.open(this.addAllergyDialog!);
  }

  getTooltipText(allergy: any): string {
    return withPatientReported(`Reaction: ${allergy.reaction || 'Not Provided'}`, allergy);
  }

  editAllergy(allergy: any): void {
    this.editingAllergy = { ...allergy };
    this.dialog.open(this.addAllergyDialog!);
  }

  saveAllergy(): void {
    if (!this.editingAllergy.allergy) return;
    const index = this.allergies.findIndex(c => c.id === this.editingAllergy.id);
    if (index !== -1) {
      this.allergies[index] = this.editingAllergy;
    } else {
      this.allergies.push(this.editingAllergy);
    }
    this.emitAllergies();
    this.dialog.closeAll();
  }


  cancelEdit(): void {
    this.dialog.closeAll();
  }

  removeAllergy(allergy: any): void {
    const index = this.allergies.indexOf(allergy);
    if (index !== -1) {
      this.allergies.splice(index, 1);
      this.emitAllergies();
    }
  }

  toggleNoAllergies(): void {
    this.noAllergiesChanged.emit(this.noAllergies);
    if (this.noAllergies) {
      this.allergiesChanged.emit([]);
    } else {
      this.emitAllergies();
    }
  }

  private emitAllergies(): void {
    const emittedAllergies = this.allergies.map(allergy => {
      if (typeof allergy.id === 'number') {
        const { id, ...rest } = allergy;
        return rest;
      }
      return allergy;
    });
    this.allergiesChanged.emit(emittedAllergies);
  }
}